import React, { useState } from "react";
import { Modal, Checkbox, Button } from "antd";
import styled from "styled-components";
import { toast } from "react-toastify";
import { apiPut } from "../../../Utils/api";

const PinCategoryModal = ({
  visible,
  onClose,
  assignedCategories,
  pinnedCategories,
  handleList,
  feedId,
}) => {
  const [selectedCategories, setSelectedCategories] = useState(
    pinnedCategories || []
  );

  const handleChange = (checkedValues) => {
    setSelectedCategories(checkedValues);
  };

  const handleOk = async () => {
    // if (selectedCategories.length === 0 || !feedId) {
    //   onClose();
    //   return;
    // }

    // console.log(feedId, "feedId", selectedCategories, "selectedCategories");

    try {
      await apiPut(`/api/feeds/${feedId}`, {
        pinned_categories: [...selectedCategories],
      });
      handleList();
      toast.info("This Feed is pinned successfully for selected categories", {
        theme: "colored",
      });
      onClose();
    } catch (error) {
      console.error("Error updating pinned categories:", error);
    }
  };

  return (
    <Modal open={visible} width={500} onCancel={onClose} footer={null}>
      <Wrapper>
        <h2>Select Category to Pin</h2>
        <CheckboxGroupWrapper>
          <Checkbox.Group
            options={assignedCategories?.categories}
            value={selectedCategories}
            onChange={handleChange}
          />
        </CheckboxGroupWrapper>
        <div className="btn-flex">
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleOk}>
            Save
          </Button>
        </div>
      </Wrapper>
    </Modal>
  );
};

export default PinCategoryModal;

const Wrapper = styled.div`
  width: 100%;

  h2 {
    margin-bottom: 16px;
  }

  .btn-flex {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
`;

const CheckboxGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
  }
`;
